export default __webpack_public_path__ + "static/academy-hero-second-glow-b1687e689fdfef55d881ae7c5b04b6da.svg";